import { apiRequest } from '@/core';
import { type InviteMemberPayload } from '@/slices/members/types';

export const inviteMemberRequest = async ({
  propertyId,
  member,
}: InviteMemberPayload) =>
  apiRequest<void>({
    endpoint: `api/members/${propertyId}/invite`,
    method: 'POST',
    body: member,
  });
